import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/usercenter/shiming.png';
import _imports_1 from '@assets/images/usercenter/home.png';
import _imports_2 from '@assets/images/usercenter/nft.png';
import _imports_3 from '@assets/images/usercenter/guanzhu.png';
import _imports_4 from '@assets/images/usercenter/zhichidexiangmu.png';
import _imports_5 from '@assets/images/usercenter/kanhao.png';
import _imports_6 from '@assets/images/usercenter/quanbudingdan.png';
import _imports_7 from '@assets/images/usercenter/daifukuan.png';
import _imports_8 from '@assets/images/usercenter/daifahuo.png';
import _imports_9 from '@assets/images/usercenter/daishouhuo.png';
import _imports_10 from '@assets/images/usercenter/tuikuan.png';
import _imports_11 from '@assets/images/usercenter/pingjia.png';
import _imports_12 from '@assets/images/usercenter/faqi.png';
import _imports_13 from '@assets/images/usercenter/gouwuche.png';
import _imports_14 from '@assets/images/usercenter/youhuiquan.png';
import _imports_15 from '@assets/images/usercenter/shouhuodihzi.png';
import _imports_16 from '@assets/images/usercenter/renzheng.png';
import _imports_17 from '@assets/images/usercenter/tuichudenglu.png';
const _withScopeId = n => (_pushScopeId("data-v-4e659e12"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "center-box"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-bg"
}, null, -1));
const _hoisted_4 = {
  class: "userinfo"
};
const _hoisted_5 = {
  class: "img"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  class: "username"
};
const _hoisted_9 = {
  class: "shiming"
};
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_11 = {
  key: 1,
  src: "https://p6.moimg.net/mdwxapp/ucenter_authCompany_icon.png",
  alt: ""
};
const _hoisted_12 = {
  class: "id"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = {
  class: "ul"
};
const _hoisted_16 = {
  key: 0,
  class: "tips"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "我的藏品", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "关注的人", -1));
const _hoisted_21 = [_hoisted_19, _hoisted_20];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "支持的项目", -1));
const _hoisted_24 = [_hoisted_22, _hoisted_23];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "看好的项目", -1));
const _hoisted_27 = [_hoisted_25, _hoisted_26];
const _hoisted_28 = {
  class: "orderlist"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "全部订单", -1));
const _hoisted_31 = [_hoisted_29, _hoisted_30];
const _hoisted_32 = {
  key: 0,
  class: "tips"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "待付款", -1));
const _hoisted_35 = {
  key: 0,
  class: "tips"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "待发货", -1));
const _hoisted_38 = {
  key: 0,
  class: "tips"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "待收货", -1));
const _hoisted_41 = {
  key: 0,
  class: "tips"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "退款/售后", -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: ""
}, null, -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "评价", -1));
const _hoisted_46 = [_hoisted_44, _hoisted_45];
const _hoisted_47 = {
  class: "uicon"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: ""
}, null, -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "发起众筹", -1));
const _hoisted_50 = [_hoisted_48, _hoisted_49];
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: ""
}, null, -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "购物车", -1));
const _hoisted_53 = [_hoisted_51, _hoisted_52];
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  alt: ""
}, null, -1));
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "优惠券", -1));
const _hoisted_56 = [_hoisted_54, _hoisted_55];
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  alt: ""
}, null, -1));
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "收货地址", -1));
const _hoisted_59 = [_hoisted_57, _hoisted_58];
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  alt: ""
}, null, -1));
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "账户认证", -1));
const _hoisted_62 = [_hoisted_60, _hoisted_61];
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  alt: ""
}, null, -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "退出登录", -1));
const _hoisted_65 = [_hoisted_63, _hoisted_64];
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hotproject"
}, "· 热门项目 ·", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_main_content = _resolveComponent("main-content");
  return !$data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.message
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $data.user_info.icon,
    alt: ""
  }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString($data.user_info.username), 1), _createElementVNode("div", _hoisted_9, [$data.user_info.auth_cate == 11 ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true), $data.user_info.auth_cate == 21 || $data.user_info.auth_cate == 31 || $data.user_info.auth_cate == 32 ? (_openBlock(), _createElementBlock("img", _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, "ID " + _toDisplayString($data.user_info.id), 1)])]), _createElementVNode("div", {
    class: "home",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toHome && $options.toHome(...args))
  }, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    class: "li",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.tonft && $options.tonft(...args))
  }, [$data.nft_num > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($data.nft_num), 1)) : _createCommentVNode("", true), _hoisted_17, _hoisted_18]), _createElementVNode("div", {
    class: "li",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.topeople && $options.topeople(...args))
  }, _hoisted_21), _createElementVNode("div", {
    class: "li",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.tobay && $options.tobay(...args))
  }, _hoisted_24), _createElementVNode("div", {
    class: "li",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.tolike && $options.tolike(...args))
  }, _hoisted_27)])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
    class: "li",
    onClick: _cache[5] || (_cache[5] = $event => $options.toOrder('100'))
  }, _hoisted_31), _createElementVNode("div", {
    class: "li",
    onClick: _cache[6] || (_cache[6] = $event => $options.toOrder('101'))
  }, [$data.orderListShow && $data.orderData.wait_pay.count > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($data.orderData.wait_pay.count), 1)) : _createCommentVNode("", true), _hoisted_33, _hoisted_34]), _createElementVNode("div", {
    class: "li",
    onClick: _cache[7] || (_cache[7] = $event => $options.toOrder('102'))
  }, [$data.orderListShow && $data.orderData.wait_send.count > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString($data.orderData.wait_send.count), 1)) : _createCommentVNode("", true), _hoisted_36, _hoisted_37]), _createElementVNode("div", {
    class: "li",
    onClick: _cache[8] || (_cache[8] = $event => $options.toOrder('103'))
  }, [$data.orderListShow && $data.orderData.wait_receive.count > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString($data.orderData.wait_receive.count), 1)) : _createCommentVNode("", true), _hoisted_39, _hoisted_40]), _createElementVNode("div", {
    class: "li",
    onClick: _cache[9] || (_cache[9] = $event => $options.toOrder('200'))
  }, [$data.orderListShow && $data.orderData.refund.count > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString($data.orderData.refund.count), 1)) : _createCommentVNode("", true), _hoisted_42, _hoisted_43]), _createElementVNode("div", {
    class: "li",
    onClick: _cache[10] || (_cache[10] = (...args) => $options.toEvaluate && $options.toEvaluate(...args))
  }, _hoisted_46)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", {
    class: "li",
    onClick: _cache[11] || (_cache[11] = (...args) => $options.faqi && $options.faqi(...args))
  }, _hoisted_50), _createElementVNode("div", {
    class: "li",
    onClick: _cache[12] || (_cache[12] = (...args) => $options.tocart && $options.tocart(...args))
  }, _hoisted_53), _createElementVNode("div", {
    class: "li",
    onClick: _cache[13] || (_cache[13] = (...args) => $options.tocard && $options.tocard(...args))
  }, _hoisted_56), _createElementVNode("div", {
    class: "li",
    onClick: _cache[14] || (_cache[14] = (...args) => $options.address && $options.address(...args))
  }, _hoisted_59), $data.user_info.auth_cate != 11 && $data.user_info.auth_cate != 21 && $data.user_info.auth_cate != 31 && $data.user_info.auth_cate != 32 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "li",
    onClick: _cache[15] || (_cache[15] = (...args) => $options.cheakId && $options.cheakId(...args))
  }, _hoisted_62)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "li",
    onClick: _cache[16] || (_cache[16] = (...args) => $options.outlogin && $options.outlogin(...args))
  }, _hoisted_65)]), _hoisted_66, _createVNode(_component_main_content, {
    ad_position: _ctx.person_page_recommen
  }, null, 8, ["ad_position"])]));
}